module.exports = __webpack_public_path__ + "img/reset.18d26882.png";